import { AxiosResponse } from 'axios'
import { IFilter, UpdateBody } from 'types/common'
import { api } from 'API'
import { IEcnSuggestion, IEcnSuggestionWithRelations } from 'interfaces/ecnSuggestion'
import { IEcnSuggestionAttachment } from 'interfaces/ecnSuggestionAttachement'

export async function getEcnSuggestions(filter: IFilter<IEcnSuggestion> = {}): Promise<IEcnSuggestionWithRelations[]> {
  const ecnSuggestions: AxiosResponse = await api.get(`/ecn-suggestions`, {
    params: { filter: JSON.stringify(filter) }
  })
  return ecnSuggestions.data
}

export async function createEcnSuggestion(ecnSuggestion: UpdateBody<IEcnSuggestion>): Promise<IEcnSuggestion> {
  const resp = await api.post('/ecn-suggestions', ecnSuggestion)
  return resp.data
}

export async function deleteEcnSuggestion(ecnSuggestionId: number): Promise<void> {
  if (!ecnSuggestionId) return
  await api.delete(`/ecn-suggestions/${ecnSuggestionId}`)
}

export async function createEcnSuggestionAttachment(
  attachement: UpdateBody<IEcnSuggestionAttachment>
): Promise<IEcnSuggestionAttachment> {
  const resp = await api.post('/ecn-suggestion-attachments', attachement)
  return resp.data
}

export async function createMultipleEcnSuggestionAttachment(
  ecnSuggestionAttachments: any
): Promise<IEcnSuggestionAttachment> {
  const resp = await api.post('/ecn-suggestion-attachments/multiple', { ecnSuggestionAttachments })
  return resp.data
}
